// HOMEOWNERS
export const REFINANCING_TOPIC_KEY = 'refinancing_to_sponsor'
export const HOMEOWNER_SHORT_TERM_RENTALS_TOPIC_KEY =
  'homeowner_short_term_rentals_to_customer'
export const HOME_INSURANCE_TOPIC_KEY = 'home_insurance_to_customer'
export const REVERSE_MORTGAGE_TOPIC_KEY = 'reverse_mortgage_to_sponsor'
export const PRINCIPAL_PAYMENTS_TOPIC_KEY = 'principal_payments_to_sponsor'
export const HOMEOWNER_EMAIL_UPDATE_TOPIC_KEY =
  'homeowner_email_update_to_customer'
export const HOME_VALUE_TOPIC_KEY = 'home_value_to_sponsor'
export const HOMEOWNER_EMERGENCY_FUND_TOPIC_KEY =
  'homeowner_emergency_fund_to_sponsor'
export const HOME_IMPROVEMENTS_TOPIC_KEY = 'home_improvements_to_sponsor'
export const HOMEOWNER_ADD_SPACE_TOPIC_KEY = 'homeowner_add_space_to_sponsor'
export const HOMEOWNER_STUDENT_DEBT_TOPIC_KEY =
  'homeowner_student_debt_to_sponsor'
export const HOMEOWNER_CREDIT_CARD_DEBT_TOPIC_KEY =
  'homeowner_credit_card_debt_to_sponsor'
export const HOMEOWNER_ENERGY_IMPROVEMENTS_TOPIC_KEY =
  'homeowner_energy_improvements_to_sponsor'
export const HOMEOWNER_CASHOUT_OPTIONS_TOPIC_KEY =
  'homeowner_cashout_options_to_sponsor'
export const HOMEOWNER_INVESTMENTS_TOPIC_KEY =
  'homeowner_investments_to_sponsor'
export const EQUITY_SMART_SEARCH_TOPIC_KEY = 'equity_smart_search_to_sponsor'
export const MORTGAGE_INSURANCE_TOPIC_KEY = 'mortgage_insurance_to_sponsor'
export const USING_EQUITY_TOPIC_KEY = 'using_equity_to_sponsor'
export const WHAT_TO_SELL_FOR_TOPIC_KEY = 'what_to_sell_for_to_customer'
export const HOME_APPRECIATION_TOPIC_KEY = 'home_appreciation_to_customer'
export const HOMEOWNER_CASH_POSITION_TOPIC_KEY =
  'homeowner_cash_position_to_customer'
export const IF_THEY_SHOULD_SELL_TOPIC_KEY = 'homeowner_should_sell_to_customer'
export const HOMEOWNER_MARKET_TOPIC_KEY = 'homeowner_market_to_customer'
export const SHOULD_SELL_MARKET_TOPIC_KEY =
  'homeowner_should_sell_market_to_customer'
export const PURCHASING_POWER_TOPIC_KEY = 'purchasing_power_to_customer'
export const DREAM_HOME_TOPIC_KEY = 'buying_dream_home_to_customer_with_notify'
export const INVESTMENT_PROPERTY_TOPIC_KEY =
  'investment_property_to_customer_with_notify'
export const SELLING_HOME_TOPIC_KEY = 'selling_home_to_customer_with_notify'
export const SECOND_HOME_TOPIC_KEY = 'second_home_to_customer_with_notify'
export const MORTGAGE_COACH_TOPIC_KEY = 'mortgage_coach_to_customer'
export const VIDEO_EMAIL_TOPIC_KEY = 'video_email_to_sponsor'

// BUYERS
export const BUYER_PREQUAL_REQUEST_TOPIC_KEY =
  'buyer_prequal_request_to_customer'
// The topic for this key says "Pre-Qual Request" but it only shows up for clients that have pre-quals already
export const BUYER_WITH_PREQUAL_TOPIC_KEY = 'buyer_with_prequal_to_customer'
export const BUYER_EXPLORING_MARKETS_TOPIC_KEY =
  'buyer_exploring_markets_to_customer'
export const BUYER_GENERAL_INQUIRY_TOPIC_KEY =
  'buyer_general_inquiry_to_customer'
export const BUYER_AFFORDABILITY_TOPIC_KEY = 'buyer_affordability_to_customer'
export const BUYER_SHORT_TERM_RENTALS_TOPIC_KEY =
  'buyer_short_term_rentals_to_customer'
export const BUYER_LISTINGS_TOPIC_KEY = 'buyer_listings_to_customer'
export const BUYER_EMAIL_UPDATE_TOPIC_KEY = 'buyer_email_update_to_customer'
export const BUYER_ZIP_CODE_TOPIC_KEY = 'buyer_zip_code_to_customer'

// HOME SEARCH
export const LISTINGS_DIRECT_MESSAGE_TOPIC_KEY = 'listings_direct_message'
